<script setup lang="ts">
import { onMounted } from 'vue'

const props = defineProps<{
    availableGroups: { id: string; name: string; exam: string }[]
}>()

const emit = defineEmits<{
    groupSelected: [groupId: string]
    close: [value?: boolean]
}>()

const selectGroup = (groupId: string) => {
    emit('groupSelected', groupId)
}

const emitClose = () => {
    emit('close', true)
}

onMounted(() => {
    const firstGroup = document.querySelector('.groups-dropdown__group:first-child') as HTMLElement | undefined
    firstGroup?.focus()
})
</script>

<template>
    <div class="groups-dropdown" @focusout="emitClose">
        <div
            v-for="(group, index) in props.availableGroups"
            :key="group.id"
            class="groups-dropdown__group"
            :autofocus="index === 0 ? true : false"
            tabindex="0"
            @mousedown.stop.prevent="selectGroup(group.id)"
        >
            <div class="groups-dropdown__group-name">
                {{ group.name }}
            </div>
            <div class="groups-dropdown__group-exam">
                {{ group.exam }}
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.groups-dropdown {
    width: 304px;
    background-color: $white;
    box-shadow: 0 4px 12px 0 rgba($brand-black, 0.1);
    padding: 3px 0;
    border-radius: 6px;
    max-height: 194px;
    overflow: auto;

    &__group {
        display: flex;
        justify-content: space-between;
        align-content: center;
        cursor: pointer;
        user-select: none;
        padding: 6px 13px;
        outline: none;

        &:hover {
            background: $gray-background;
        }

        .groups-dropdown__group-name {
            font-size: 15px;
            white-space: nowrap;
        }

        .groups-dropdown__group-exam {
            font-size: 13px;
            line-height: 18px;
            color: $slate-03;
        }
    }
}
</style>
